import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_QUANTITY_Interface, QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { QUANTITYService } from 'src/app/Service/QUANTITY/QUANTITY.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-QUANTITY',
  templateUrl: './QUANTITY.component.html',
  styleUrls: ['./QUANTITY.component.css']
})
export class QUANTITYComponent implements OnInit {
  Filter_title:String=""
  page:number=0
  Procssing:boolean=false
  DataList_Quantity:Array<General_Interface>=[]

  certificate_id:String="0"
  dataentity_id:String="0"

  Data_Seleted_Delete:General_Interface=Empty_General_Interface()
  Data_Seleted_ShowList:General_Interface=Empty_General_Interface()

  constructor(
    private Quantity_Service:QUANTITYService,
    private Alertify_Service:AlertifyService,
    private DataEntityMain_Service:DataEntityMainService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(53).subscribe(
      data=>{
        this.ReadData_Quantity()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }



  ReadData_Quantity(){
    this.Procssing=true
    this.Quantity_Service.GetRecord1(this.Data_Seleted_ShowList.id).subscribe(
      data=>{
        this.DataList_Quantity=data
        this.Read_DataEntity_Certificate()

        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Show_SubGroup(item)
  {
    this.Data_Seleted_ShowList=item
    this.ReadData_Quantity()
  }

  Back_Group(){
    this.Data_Seleted_ShowList=Empty_General_Interface()
    this.ReadData_Quantity()
  }

 //#region Add


  txtGroupTitle:String=''
  Proccesing_Add:boolean=false
  modalRef_Add: any;

  openModal_Add(template: TemplateRef<any>) {
    this.txtGroupTitle=''
    this.modalRef_Add = this.modalService.show(template);
  }

  Add(){
    if(!this.txtGroupTitle)
    {
      this.Alertify_Service.ErrorMessage("عنوان  را وارد نمائید")
    }
    else{
      this.Proccesing_Add=true
      var temp:QUANTITY_Interface=Empty_QUANTITY_Interface();
      temp.id=0
      temp.title=this.txtGroupTitle,
      temp.parent=this.Data_Seleted_ShowList.id

      this.Quantity_Service.EditAddQUANTITY(temp).subscribe(
        data=>{
          this.Proccesing_Add=false
          this.txtGroupTitle=''
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.ReadData_Quantity()
        }
      )
    }

  }

 //#endregion

 //#region Edit

  Proccesing_Edit:boolean=false
  modalRef_Edi: any;

  openModal_Edi(template: TemplateRef<any>,item:General_Interface) {
    this.Data_Seleted_Delete=item
    this.txtGroupTitle=this.Data_Seleted_Delete.title
    this.modalRef_Edi = this.modalService.show(template);

    this.certificate_id=item.userDsc
    this.dataentity_id=item.dsc
  }

  Edit(){
    if(!this.txtGroupTitle)
    {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید")
    }
    else{
      this.Proccesing_Edit=true
      var temp:QUANTITY_Interface=Empty_QUANTITY_Interface();
      temp.id=this.Data_Seleted_Delete.id
      temp.title=this.txtGroupTitle,

      temp.certificate_id=Number(this.certificate_id),
      temp.dataentity_id=Number(this.dataentity_id),

      this.Quantity_Service.EditAddQUANTITY(temp).subscribe(
        data=>{
          this.Proccesing_Edit=false
          //this.txtGroupTitle=''
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.ReadData_Quantity()
        }
      )
    }

  }

  //#endregion


  //#region Delete


  modalRef_Delete: any;

  openModal_Delete(template: TemplateRef<any>,item) {
    this.Data_Seleted_Delete=item
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete(){

    this.modalRef_Delete.hide()
    this.Quantity_Service.DeleteQUANTITY(this.Data_Seleted_Delete.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Quantity()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Doamin(item:General_Interface){

    this.Quantity_Service.DomainQUANTITY(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("تغییر انجام شد")
        this.ReadData_Quantity()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion

  //#region Tree

  DataList_Quantity_Parent:Array<QUANTITY_Interface>=[]
  DataList_Quantity_Child:Array<QUANTITY_Interface>=[]

  ReadData_Quantity_Tree(){
    this.Procssing=true
    this.DataList_Quantity_Parent=[]
    this.DataList_Quantity_Child=[]
    this.Quantity_Service.GetTree().subscribe(
      data=>{
        this.DataList_Quantity_Parent=data['parent']
        this.DataList_Quantity_Child=data['child']

        for(let item of this.DataList_Quantity_Parent)
        {
          item.child=[]
          for(let itemdetail of this.DataList_Quantity_Child)
          {
            if(itemdetail.parent==item.id)
            {
              item.child.push(itemdetail)
            }
          }
        }

        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Data_List_Menu_Change(id){
    this.DataList_Quantity_Parent[id].del=!this.DataList_Quantity_Parent[id].del
  }

  //#endregion

  //#region Controller

  Show_ControllerForm(item:General_Interface)
  {
    this.Data_Seleted_ShowList=item
    this.Switcher_View='Controller'
  }

  Back_From_Controller_Form() {
    this.Data_Seleted_ShowList = Empty_General_Interface()
    this.set_Switcher_View('List')
  }

  //#endregion

  Switcher_View:string='List'
  set_Switcher_View(item:string)
  {
    if(item=='Tree')
    {
      this.ReadData_Quantity_Tree()
    }
    this.Switcher_View=item
  }

  DataEntity_List:Array<General_Interface>=[]
  Certificate_List:Array<General_Interface>=[]
  Read_DataEntity_Certificate(){
    this.DataEntityMain_Service.GetDataEntity().subscribe(
      data=>{
        this.Certificate_List=data['certificate']
        this.DataEntity_List=data['dataEntity']
      }
    )
  }


}
